import styled from 'styled-components';

import {
  Flex,
  Text,
} from 'web-styled';

export const AmountWrapper = styled(Flex).attrs({
  align: 'center',
})`
  position: relative;
  width: 20%;

  & > span {
    position: absolute;
    top: 41px;
    left: 12px;
    z-index: 2;
  }

  input {
    padding-left: 22px;
  }
`;

export const SlugPrefix = styled(Text).attrs({
  color: 'primary',
})`
  position: relative;
  top: 10px;
`;

export const Item = styled(Flex).attrs({
  column: true,
})`
  width: 100%;
  padding: 10px 0;
  border-top: 1px solid #E7EDF2;

  &:last-of-type {
    border-bottom: 1px solid #E7EDF2;
  }
`;
